import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import Layout from "./layout.js";
import Home from "./pages/Home.js";
import Lunch from "./pages/Lunch.js";
import Drinks from "./pages/Drinks.js";
import Dinner from "./pages/Dinner.js";
import Dessert from "./pages/Dessert.js";
import PartyCourse from "./pages/PartyCourse.js";
import Takeout from "./pages/Takeout.js";
import UberEats from "./pages/UberEats.js";
import News from "./pages/News.js";
import { ToastContainer } from "react-toastify";
import BusinessHours from "./pages/BusinessHours.js";
import ContactForm from "./pages/ContactForm.js";
import ShopInformation from "./pages/ShopInformation.js";
import NaanInformation from "./pages/NaanInformation.js";

function App() {
  useEffect(() => {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
  }, []);
  return (
    <Router>
      <Layout>
        <Routes>
       
          <Route path="/" element={<Home />} />
          <Route path="/lunch" element={<Lunch />} />
          <Route path="/drinks" element={<Drinks />} />
          <Route path="/dinner" element={<Dinner />} />
          <Route path="/dessert" element={<Dessert />} />
          <Route path="/party" element={<PartyCourse />} />
          <Route path="/takeout" element={<Takeout />} />
          <Route path="/contact" element={<ContactForm />} />
          <Route path="/company" element={<BusinessHours />} />
          <Route path="/delivery" element={<UberEats />} />
          <Route path="/news" element={<News />} />
          <Route path="/store" element={<ShopInformation />} />
          <Route path="/naan" element={<NaanInformation />} />
        </Routes>
        <ToastContainer />
      </Layout>
    </Router>
  );
}

export default App;
